module.exports = __webpack_public_path__ + "static/Museo700-Regular-ca11daabbd675a39710aeacd18893b57.woff";